import { AfterViewInit, Component, HostListener, NgZone, OnDestroy, OnInit } from "@angular/core";
import { MerchantControllerService, UserControllerService } from "./@services/gen";
import { LocalstorageService } from "./@services/localstorage.service";
import { UserShiftService } from "./@services/user-shift.service";
import { AuthService } from "./@services/auth.service";
import { KitchenService } from "./@services/kitchen.service";


@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit, AfterViewInit {
  title = "dpos-pos-ui";

  constructor(
    private userService: UserControllerService,
    private ls: LocalstorageService,
    private userShiftService: UserShiftService,
    private ms: MerchantControllerService,
    private zone: NgZone,
    private customAuthService: AuthService,
    private customKitchenService: KitchenService,

  ) {
  }

  async ngOnInit() {
    const merchant = await this.loadMerchant();
    if (!merchant) {
      return;
    }
    this.loadShiftSummary();
  }

  ngAfterViewInit(): void {
    this.zone.runOutsideAngular(() => {
      this.customKitchenService.startTimerIncomingKitchenOrder();
    });
  }

  @HostListener("window:beforeunload", ["$event"])
  beforeUnload() {
    console.log("==> Window Unloading");
    console.log("Stopping timer for incoming kitchen order");
    this.customKitchenService.stopTimerIncomingKitchenOrder();
  }

  async loadMerchant() {
    const user = this.customAuthService?.getUser();
    const merchantId = user && user.merchants && user.merchants.length > 0 ? user.merchants[0].id : null;
    if (!merchantId) {
      return null;
    }

    let merchant = await this.ms
      .getMerchantPost({
        id: merchantId
      })
      .toPromise();
    if (!merchant) {
      return null;
    }

    this.ls.saveMerchant(merchant);
    return merchant;
  }

  private loadShiftSummary() {
    this.userService
      .getUserShiftSummaryPost({
        merchantId: this.ls.getMerchant().id,
        cashierId: this.customAuthService.getUser().userId
      })
      .subscribe(
        (userShift) => {
          if (userShift) {
            this.userShiftService.saveUserShift(userShift);
          }
        },
        (error) => {
        }
      );
  }
}
